<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      :page.sync="page"
      ref="crud"
      @row-del="rowDel"
      v-model="form"
      :permission="permissionList"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @selection-change="selectionChange"
      :header-cell-class-name="headerCellClassName"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-upload style="float: left" class="filter-item" :show-file-list="false" :action="handleImport()" :headers="uploadHeaders()" :on-success="uploadSuc">
          <el-button type="primary" icon="upload">导入</el-button>
        </el-upload>
        <div style="float: left">
          <el-button id="files" size="small" type="primary" @click="downModule()">下载模版</el-button>
          <el-button type="danger" size="small" icon="el-icon-delete" plain v-if="permission.user_userconfigurevip_delete" @click="handleDelete">删 除</el-button>
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, submit, remove, moduleExcel } from '@/api/user/userconfigurevipNew'
import { mapGetters } from 'vuex'
import FileSaver from 'file-saver'
import { getToken } from '@/util/auth'
import { baseUrl } from '@/config'
import func from '@/util/func'
export default {
  data() {
    return {
      fileList: [],
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: '序号',
        tip: false,
        border: false,
        index: true,
        viewBtn: true,
        selection: true,
        addBtn: false,
        editBtn: false,
        menuWidth: 140,
        delBtnIcon: '',
        searchMenuSpan: 5,
        column: [
          /* {
            label: '身份证',
            prop: 'idCardNo',
          },*/
          {
            label: '用户名',
            prop: 'userName',
            search: true,
            width: 80
          },
          {
            label: '手机号码',
            prop: 'mobile',
            search: true,
            width: 110
          },
          {
            label: '会员充值类型',
            prop: 'vipType',
            width: 110
          },
          {
            label: '是否激活',
            prop: 'vipIsActivation',
            width: 80
          },
          {
            label: '年增量',
            prop: 'vipYear',
            width: 70
          },
          {
            label: '月增量',
            prop: 'vipMonth',
            width: 70
          },
          {
            label: '日增量',
            prop: 'vipDay',
            width: 70
          },
          {
            label: '方案动态调整次数',
            prop: 'vipAdjustCount',
            width: 140
          },
          {
            label: '会员时限',
            prop: 'startTime',
            overHidden: true,
            formatter: row => {
              // (!row.startTime && row.vipType) === '体验会员' ? '暂未使用' : (row.startTime + '至' + row.endTime)
              return row.vipType !== '体验会员' ? row.startTime + '至' + row.endTime : row.startTime ? row.startTime + '至 ...' : '暂未使用'
            }
          },
          // {
          //   label: '会员结束时间',
          //   prop: 'endTime'
          // },
          {
            label: '导入时间',
            prop: 'createTime',
            width: 110,
            overHidden: true
          },
          {
            label: '导入状态',
            prop: 'status',
            search: true,
            width: 80,
            dicData: [
              { label: '未完成', value: 1 },
              { label: '已完成', value: 2 }
            ]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.user_userconfigurevip_add,
        viewBtn: this.permission.user_userconfigurevip_view,
        delBtn: this.permission.user_userconfigurevip_delete,
        editBtn: this.permission.user_userconfigurevip_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    // excle导入
    uploadHeaders() {
      return { token: getToken() }
    },

    handleImport() {
      return baseUrl + '/user/userConfigureVipNew/excel/save'
      // return baseUrl + '/user/userConfigureVipNew/excel/saveCardCouponsLibrary'
    },

    uploadSuc(response) {
      if (response.success) {
        this.$message({ message: '操作成功', type: 'success' })
        this.onLoad(this.page)
      } else {
        this.$message({ message: '操作失败', type: 'error' })
      }
    },

    // 模版
    downModule() {
      moduleExcel().then(response => {
        console.log('csssss')
        console.log(response)
        FileSaver.saveAs(response, '导入模版' + '.xls')
      })
    },

    rowSave(row, done, loading) {
      submit(row)
        .then(() => {
          done()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
        .catch(() => {
          loading()
        })
    },
    rowUpdate(row, index, done, loading) {
      submit(row)
        .then(() => {
          done()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
        .catch(() => {
          loading()
        })
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset() {
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.onLoad(this.page, params)
      done()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },

    onLoad(page, params = {}) {
      const wxUserId = window.localStorage.getItem('pcUserId');
      getList(page.currentPage, page.pageSize, params).then(res => {
      if (wxUserId === '2043870969731301377' && res.data.records.length > 0) {
          res.data.records.forEach(item => {
              item.mobile = func.maskPhone(item.mobile);
              item.userName = func.maskName(item.userName);
          });
        }
        const data = res.data
        console.log(data)
        this.page.total = data.total
        this.data = data.records
      })
    }
  }
}
</script>
<style lang="scss">
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
